import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { VERSION, ENV } from "./lib/config/api";

export default function App() {
    console.log(VERSION)
    console.log(ENV);
    return (
        <RouterProvider router={router} />
    )
}